module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.925054ba.woff2";